import React, { Component } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import GovernanceCard from "../GovernanceCard/GovernanceCard";

import leftBtn from "./../../../assets/images/arrow-left.png";
import leftBtnBlr from "./../../../assets/images/arrow-left-blur.png";
import rightBtn from "./../../../assets/images/arrow_right.png";
import rightBtnBlr from "./../../../assets/images/arrow-right-blur.png";
export default class GovernanceSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliders: null,
      newSlider: null,
      sliderBtn: false,
      activeSlide2: 0,
      activeSlide: 0,
      hasLoaded: false
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);


  }

  listenScrollEvent(event) {


  }


  next() {
    this.slider.slickNext();
    this.setState({ sliderBtn: true })

  }

  previous() {
    this.slider.slickPrev();
  }
  render() {








    const settings = {
      className: "center",
      dots: true,
      infinite: false,
      centerPadding: "60px",
      slidesToShow: 4,
      speed: 500,
      rows: 1,
      slidesToScroll: 4,
      slidesPerRow: 1,

      beforeChange: (current, next) => this.setState({ activeSlide: next }),
      afterChange: current => this.setState({ activeSlide2: current + 4 }),
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            rows: 1,

            afterChange: current => this.setState({ activeSlide2: current + 1 }),
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            afterChange: current => this.setState({ activeSlide2: current + 2 }),

          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            afterChange: current => this.setState({ activeSlide2: current + 3 }),
            dots: true,
          },
        },
      ],
    };



    return (
      <>
        {this.props?.sliderInfo ?
          <div className="team-slider">
            <Slider ref={(c) => (this.slider = c)} {...settings}>
              {this.props?.sliderInfo?.map((teamInfo, index) => (
                <GovernanceCard
                  key={Date.now() + Math.random()}
                  sliderCard={true}
                  sliderInfo={teamInfo}
                  index={index + 10}
                  cardHeight={550}
                ></GovernanceCard>
              ))}
            </Slider>

            <div className="d-flex justify-content-center">
              <div className="govern-slider-btn">
                <div className="d-flex justify-content-between  pt-5  pt-md-3">
                  <img
                    src={this.state.activeSlide === 0 ? leftBtn : leftBtnBlr}
                    alt=""
                    className="img-fluid pinter-cursor"
                    onClick={this.previous}
                  />
                 
                  <img
                    src={this.state.activeSlide2 === this.props?.sliderInfo?.length ? rightBtnBlr :
                      this.state.activeSlide2 === this.state.sliders?.length + 1 ? rightBtnBlr : rightBtn}
                    alt=""
                    className="img-fluid pinter-cursor"
                    onClick={this.next}
                  />
                
                </div>
              </div>
            </div>
          </div>
          : null}

      </>
    );
  }
}
